import React from 'react';
import styled from 'styled-components';
import { FaSearch, FaFileAlt, FaRupeeSign, FaCheckCircle } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const ProcessSection = styled.section`
  padding: 80px 0;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const Step = styled.div`
  position: relative;
  text-align: center;
  padding: 0 20px;
  width: 25%;
  
  &::after {
    content: '';
    position: absolute;
    top: 30px;
    right: -50%;
    width: 100%;
    height: 3px;
    background-color: ${props => props.theme.colors.primaryColor};
    z-index: -1;
  }
  
  &:last-child::after {
    display: none;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 50%;
    margin-bottom: 40px;
    
    &::after {
      display: none;
    }
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    width: 100%;
  }
`;

const StepNumber = styled.div`
  font-size: ${props => props.theme.fontSizes.large};
  font-weight: ${props => props.theme.fontWeights.bold};
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 15px;
`;

const StepIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.primaryColor};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0 auto 20px;
  position: relative;
  z-index: 1;
`;

const StepTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const StepDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.6;
`;

const EnrollmentProcess = () => {
  const steps = [
    {
      number: '01',
      title: 'Choose a Course',
      description: 'Browse our courses and select the one that aligns with your career goals and interests.',
      icon: <FaSearch />
    },
    {
      number: '02',
      title: 'Submit Application',
      description: 'Fill out the application form with your details and educational background.',
      icon: <FaFileAlt />
    },
    {
      number: '03',
      title: 'Fee Payment',
      description: 'Complete the payment process through your preferred payment method.',
      icon: <FaRupeeSign />
    },
    {
      number: '04',
      title: 'Confirmation',
      description: 'Receive confirmation of enrollment and access to course materials.',
      icon: <FaCheckCircle />
    }
  ];

  return (
    <ProcessSection>
      <div className="container">
        <SectionHeader 
          title="Enrollment Process" 
          subtitle="Simple steps to join our courses" 
        />
        
        <StepsContainer>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepNumber>{step.number}</StepNumber>
              <StepIcon>{step.icon}</StepIcon>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Step>
          ))}
        </StepsContainer>
      </div>
    </ProcessSection>
  );
};

export default EnrollmentProcess;
